export default __webpack_public_path__ + "static/2-6a2f9be22b500810b79ce2385ece812b.webp";